import { render, staticRenderFns } from "./MyFq.vue?vue&type=template&id=70726679&scoped=true"
import script from "./MyFq.vue?vue&type=script&lang=js"
export * from "./MyFq.vue?vue&type=script&lang=js"
import style0 from "./MyFq.vue?vue&type=style&index=0&id=70726679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70726679",
  null
  
)

export default component.exports